export default __webpack_public_path__ + "static/media/all.0a39a14c.svg";